import React, { useContext, useMemo } from "react";
import EmptyRow from "./Rows/EmptyRow";
import LoadingRow from "./Rows/LoadingRow";
import { RowClassName } from "../../enums";
import { TABLE_CONSTANTS } from "../../utils/appConstant";
import { TableContext } from "../../contexts/TableContext";

const TableBody: React.FC = () => {
  const { headCells, row, loading, total, data, noDataFoundMessage, rowProps, footerRow } = useContext(TableContext);

  const rows = useMemo(() => {
    const Row = row;
    if (loading) {
      return <LoadingRow colSpan={headCells.length + 1} />;
    }

    if (total === 0 || data.length === 0) {
      return <EmptyRow text={noDataFoundMessage || TABLE_CONSTANTS.noRecordsFound} colSpan={headCells.length + 1} />;
    }
    const finalRows: React.ReactNode[] = data.map((item: any, index: number) => (
      <Row key={index} item={item} {...rowProps} className={index % 2 === 0 ? RowClassName.even : RowClassName.odd} />
    ));

    if (footerRow) {
      finalRows.push(footerRow);
    }

    return finalRows;
  }, [loading, total, headCells, data, row, footerRow]);
  return (
    <tbody>
      {rows}
    </tbody>
  );
}

export default TableBody;